<template>
  <div class="home">
    <!-- 视频首屏 -->
    <section class="video" ref="videoSection">
      <video
        autoplay
        muted
        loop
        playsinline
        webkit-playsinlinex5-playsinline
        x5-video-player-type="h5"
        class="bg-video"
        ref="bgVideo"
        :src="videoSrc"
        poster="../assets/images/home/videoBg.jpg"
      ></video>
      <!-- 遮罩层 -->
      <div class="video-overlay"></div>

      <div class="video-container">
        <div class="video-text">
          <h1>{{ $t('message.homeTitle') }}</h1>
          <div class="video-text-second">{{ $t('message.homeTitleHint') }}</div>
          <div class="video-more-container" style=" justify-content:center;">
            <div class="video-more" @click="handleMenuClick( { label: 'Clinical Trial', path: '/clinicalDetail' },2)">
              <span class="text-initial">{{ $t('message.homeNavToClinical') }}</span>
              <span class="text-hover">{{ $t('message.homeNavToClinical') }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 滚动内容区 -->
    <section class="content">
      <div class="content-detail" ref="contentDetail">
        <img src="@/assets/images/home/product_title.png" class="detail-image" ref="detailImage" />
        <p class="detail-text" ref="detailText">{{ $t('message.homeProductHint') }}</p>

        <div class="video-more-container detail-button">
          <div class="video-more" @click="handleMenuClick( { label: 'TITIAN®', path: '/productDetail' },0)">
            <span class="text-initial">{{ $t('message.homeProductMore') }}</span>
            <span class="text-hover" style="left: 12%!important;">{{ $t('message.homeProductMore') }}</span>
          </div>
        </div>

        <!-- <button
          class="detail-button"
          ref="detailButton"
          @click="handleMenuClick(  { label: 'TITIAN®', path: '/productDetail' },0)"
        >{{ $t('message.homeProductMore') }}</button>-->
        <img src="@/assets/images/home/product.png" class="detail-product" />
      </div>
    </section>
  </div>
</template>

<script>
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'AppHome',

  data() {
    return {
      videoSrc: require('@/assets/videos/home_video.mp4')
    }
  },

  mounted() {
    const video = this.$refs.bgVideo
    video.muted = true

    // 移动端才处理
    if (/Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) {
      video.play().catch(() => {
        console.log('移动端自动播放被拦截，等待用户交互')
        const resume = () => {
          video.play().catch(() => {})
          document.removeEventListener('touchstart', resume)
          document.removeEventListener('click', resume)
        }
        document.addEventListener('touchstart', resume)
        document.addEventListener('click', resume)
      })
    } else {
      // 桌面端正常播放
      video.play().catch(() => {})
    }

    this.initVideoAnimation()
    this.initContentAnimation()
  },
  beforeDestroy() {
    // window.removeEventListener('resize', this.onResize)
    // window.removeEventListener('wheel', this.onWheel)
    // window.removeEventListener('resize', this.updatePadding)
  },
  methods: {
    initVideoAnimation() {
      const videoTarget = this.$refs.videoSection
      if (!videoTarget) return

      const [h1, videoSecond, videoMore] = [
        videoTarget.querySelector('h1'),
        videoTarget.querySelector('.video-text-second'),
        videoTarget.querySelector('.video-more')
      ]

      // 初始状态
      gsap.set([h1, videoSecond, videoMore], { opacity: 0, y: 30 })

      const animateVideo = play => {
        if (play) {
          gsap.to(h1, { opacity: 1, y: 0, duration: 1, delay: 0.5, ease: 'power3.out' })
          gsap.to(videoSecond, { opacity: 1, y: 0, duration: 1, delay: 0.8, ease: 'power3.out' })
          gsap.to(videoMore, { opacity: 1, y: 0, duration: 1, delay: 1.2, ease: 'power3.out' })
        } else {
          gsap.set([h1, videoSecond, videoMore], { opacity: 0, y: 30 })
        }
      }

      const observer = new IntersectionObserver(([entry]) => animateVideo(entry.isIntersecting), { threshold: 0.2 })

      observer.observe(videoTarget)
    },

    initContentAnimation() {
      const target = this.$refs.contentDetail
      if (!target) return

      const img = target.querySelector('.detail-image')
      const text = target.querySelector('.detail-text')
      const btn = target.querySelector('.detail-button')
      const product = target.querySelector('.detail-product')

      const animateContent = play => {
        if (!play) return

        gsap.set([img, text, btn, product], { clearProps: 'all' })

        gsap.from(img, { opacity: 0, y: 50, duration: 0.5, ease: 'power3.out' })
        gsap.from(text, { opacity: 0, y: 50, duration: 0.5, delay: 1, ease: 'power3.out' })
        gsap.from(btn, { opacity: 0, y: 50, duration: 0.5, delay: 1.5, ease: 'power3.out' })
        gsap.from(product, { opacity: 0, y: 50, duration: 0.5, delay: 2, ease: 'power3.out' })
      }

      const observer = new IntersectionObserver(([entry]) => animateContent(entry.isIntersecting), { threshold: 0.2 })

      observer.observe(target)
    },
    handleMenuClick(item, index) {
      if (item.path) {
        if (this.$route.path !== item.path) {
          this.$router.push(item.path)
        } else {
          this.refs.homeHeader.selectedMenu = index
        }
      }
    }
    // onResize() {
    //   this.setAnchorOffset()
    // },
    // setAnchorOffset() {
    //   const logoEl = document.querySelector('.navbar-logo')
    //   if (logoEl) {
    //     const rect = logoEl.getBoundingClientRect()
    //     this.$refs.videoText.style.left = rect.left - 20 + 'px'
    //     this.$refs.detailImage.style.left = rect.left - 20 + 'px'
    //     this.$refs.detailText.style.left = rect.left - 20 + 'px'
    //     this.$refs.detailButton.style.left = rect.left - 20 + 'px'
    //   }
    // }
    // changeLang(lang) {
    //   this.$i18n.locale = lang
    // }
  }
}
</script>

<style scoped>
.app {
  font-family: 'Helvetica Neue', Arial, sans-serif;
  color: #fff;
  background: #000;
  overflow-x: hidden;
}

.video {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0;
}
.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6); /* 黑色半透明遮罩，可调整透明度 */
  z-index: 1;
}
.bg-video {
  position: absolute;
  /* top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); */
  width: 100%;
  height: 100%;
  /* max-width: 2560px;
  max-height: 1440px; */
  object-fit: cover; /* 保持原始比例并完整显示 */
  z-index: -1;
  object-position: center center; /* 让裁切位置在中心 */
}
.video-container {
  position: absolute;
  top: 48%;
  left: 50%;
  transform: translate(-50%, -50%); /* 位移到真正的中心 */
  display: flex;
  flex-direction: column; /* 垂直排列子元素 */
  align-items: center; /* 水平居中 */
  justify-content: center; /* 垂直居中 */
  text-align: center;
  z-index: 2; /* 确保文字在遮罩层上面 */
  width: 80vw;
}

.video-text {
  text-align: center; /* 文字水平居中 */
  color: white;
}

.video-text h1 {
  font-size: var(--title-big-font-size);
  margin-bottom: 1.9rem; /* 文字和按钮间距 */
  margin-top: 0px;
  text-align: center;
  font-weight: 800;
  /* font-weight: var(--title-font-weight); */
}
.video-text-second {
  font-size: var(--subtitle-font-size);
  margin-bottom: 0.9rem; /* 文字和按钮间距 */
  text-align: center;

  font-weight: 400;

  color: #adafaf;
}

.video-more-container {
  width: 100%;
  display: inline-flex;
  justify-content: flex-start;
  margin-top: 0.9rem;
}

.video-more {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 5px 0 5px;
  height: 2.5rem;
  border-radius: 3.125rem;
  cursor: pointer;
  overflow: hidden;
  background: transparent;
  border: none;
  font-size: 1.5rem;
  font-weight: 400;
  color: #00acf8;
} /* 初始图标 */
.video-more::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 2.5rem;
  height: 100%;
  background: url('@/assets/images/home/leftIcon.png') no-repeat left center;
  background-size: 100%;
  border-radius: 3.125rem;
  z-index: 1;
  transition: opacity 0.3s ease;
} /* 背景块 */
.video-more::after {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 0%; /* 初始宽度为0 */
  height: 100%;
  background-color: #00acf8;
  border-radius: 3.125rem;
  transition: width 0.5s ease;
  z-index: 0;
} /* 初始文字 */
.text-initial {
  position: relative;
  z-index: 2;
  transition: transform 0.3s ease, opacity 0.3s ease;
  margin-left: 2.875rem;
  font-size: 1.5rem;
  font-weight: 400;
} /* hover 时显示的文字 */
.text-hover {
  position: absolute;
  left: 6%; /* 从图标右侧开始 */
  top: 0;
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 10px;
  color: #fff;
  z-index: 2;
  opacity: 0;
  transform: translateX(-20px);
  transition: transform 0.5s ease, opacity 0.5s ease;
} /* hover 动作 */
.video-more:hover::before {
  opacity: 0; /* 图标消失 */
}
.video-more:hover::after {
  width: 100%; /* 背景从左到右扩展 */
}
.video-more:hover .text-initial {
  transform: translateY(20px); /* 向下消失 */
  opacity: 0;
}
.video-more:hover .text-hover {
  transform: translateX(0); /* 滑入到原位 */
  opacity: 1; /* 显示文字 */
}

.content-detail {
  position: relative; /* 让子元素绝对定位的参考点 */
  /* height: 100vh; */
  aspect-ratio: 16 / 9;
  background-image: url('../assets/images/home/product_bg.png'); /* 替换成你的图片路径 */
  background-size: cover; /* 图片填满容器，同时保持比例 */
  background-position: center; /* 图片居中显示 */
  background-repeat: no-repeat; /* 防止重复平铺 */
}
@media (max-width: 768px) {
  .content-detail {
    height: 30.5rem;
    aspect-ratio: auto;
  }
}

.detail-image {
  max-width: 600px;
  width: 80%;
  height: auto;
  margin-bottom: 20px;
  position: absolute;
  width: 21.875rem;
  height: auto;
  top: 7rem;
  left: 18vw;
}
/* 统一绝对定位 */
/* 移动端适配 */
@media (max-width: 768px) {
  .detail-image {
    position: relative;
    left: 10vw;
    margin-bottom: 0px;
    width: 20rem;
    /* max-width: 22rem; */
    top: 0rem;
    padding-top: 5rem;
  }
}

.detail-text {
  position: absolute;
  /* left: 210px; */
  top: 11.75rem;
  left: 18vw;
  font-size: var(--subtitle-font-size);
}
@media (max-width: 768px) {
  .detail-text {
    left: 10vw;
    text-align: left;
    width: 80%;
    top: 0rem;
    /* min-height: 21rem; */
    position: relative;
    margin-top: 2rem !important;
  }
}

.detail-product {
  position: absolute;
  bottom: 0px;
  /* left: 150px; */
  width: 100%;
}

.detail-button {
  position: absolute;
  top: 14rem;
  left: 18vw;
  width: 500px;
  z-index: 3;
  /* left: 210px; */
}
/* 移动端适配 */
@media (max-width: 768px) {
  .video-text h1 {
    font-size: 3rem;
    text-align: left;
    margin-bottom: 1rem;
  }
  .video-text-second {
    text-align: left;
    margin-top: 2rem;
  }
  .video-more-container {
    /* display: block; */
    justify-content: start !important;
  }

  .video-container {
    top: 80%;
    left: 55%;
    width: 90vw;
  }

  .detail-button {
    left: 10vw;
    /* transform: translateX(-50%); */
    /* width: 30%; */
    text-align: center;
    width: 80%;
    display: flex;
    justify-content: center;
    position: relative;
    top: 0rem;
    margin-top: 2rem;
  }
}

/* .section img {
  width: 100%;
  max-width: 600px;
  border-radius: 10px;
  margin-bottom: 1rem;
  box-shadow: 0 0 10px #222;
}
.section h2 {
  margin-bottom: 0.5rem;
  font-size: 2rem;
}
.section p {
  font-size: 1.1rem;
  line-height: 1.4;
} */
</style>
